import { CryptoProGateway } from './cryptopro-gateway';
import { ReportFormSignApi } from './report-form-sign-api';
import { ReportFormSignPresenter } from './report-form-sign-presenter';
import type { SignProfile } from './sign-types';
import { ReportFormSignView } from './report-form-sign-view';

export function initReportFormSignWidget(root: HTMLElement): ReportFormSignPresenter {
  const signEndpoint = root.dataset.reportSignEndpoint;
  const signProfile = 'CAdES-BES' as SignProfile;
  const helpUrl = 'https://docs.cryptopro.ru/cades/plugin';

  const view = new ReportFormSignView(root);
  const gateway = new CryptoProGateway();
  const api = new ReportFormSignApi(signEndpoint);
  const presenter = new ReportFormSignPresenter(view, gateway, api, {
    signProfile,
    helpUrl,
  });

  presenter.init();
  return presenter;
}
